import React, { useEffect } from "react";
import { Form, Input, Select, InputNumber, Row, Col, DatePicker,  } from "antd";
import inputStyles from "../../../styles/Custom/Input.module.css";
import { genderKeys } from "../receptionKeys";
import { validateConfig } from "../../../config/validate.config";
import PatientMobileSearch from "../PatientMobileSearch";
import dayjs from "dayjs";
import useIsMobile from "../../../hooks/useIsMobile";
import useReceptionistMobilePickerProps from "../receptionistMobilePickerProps";

const PatientDetailsForm = ({
  searchedText,
  setSearchedText,
  selectedId,
  setSelectedId,
  editData,
  form,
}) => {
  const isMobile = useIsMobile();
  const mobilePickerProps = useReceptionistMobilePickerProps();

  function disabledDate(current) {
        return current && current > dayjs().endOf("day");
      }


  return (
    <>
      <PatientMobileSearch
        searchedText={searchedText}
        setSearchedText={setSearchedText}
        setSelectedId={setSelectedId}
        selectedId={selectedId}
        id={editData?.patient || editData?.id}
        form={form}
      />
      <Form.Item
        label="First Name"
        rules={validateConfig.isRequired("Patient Name")}
        name="first_name"
      >
        <Input
          className={inputStyles.mdInput}
          style={{ width: "300px" }}
          placeholder="Enter First name"
        />
      </Form.Item>
      <Form.Item
        label="Last Name"
        // rules={validateConfig.isRequired("Patient Name")}
        name="last_name"
      >
        <Input
          className={inputStyles.mdInput}
          style={{ width: "300px" }}
          placeholder="Enter Last name"
        />
      </Form.Item>
      <Row gutter={16}>
            <Col span={8}>
              <Form.Item
                label="Date Of Birth"
                name="dob"
                rules={[{ required: true, message: "Enter DOB or Age" }]}
              >
                <DatePicker
                  disabledDate={disabledDate}
                  className={inputStyles.mdDateInput}
                  style={{ width: isMobile ? "100%" : "100%" }}
                  placeholder="Select DOB"
                  {...mobilePickerProps}
                  onChange={(date) => {
                    if (date) {
                      const today = dayjs();
                      const age = today.diff(date, "year");
                      form.setFieldValue("age_by_dob", age);
                    } else {
                      form.setFieldValue("age_by_dob", null);
                    }
                  }}
                />
              </Form.Item>
            </Col>          

            <Col span={4}>
              <Form.Item
                label="Age"
                name="age_by_dob"
                rules={[
                  {
                    validator: (_, value) => {
                      if (value === undefined || value === null || value === "") {
                        return Promise.resolve();
                      }
              
                      if (!Number.isInteger(value) || value < 0) {
                        return Promise.reject(
                          new Error("Age must be a positive integer")
                        );
                      }
              
                      return Promise.resolve();
                    },
                  },
                ]}
              >

                <InputNumber
                  min={0}
                  max={120}
                  precision={0}      
                  step={1}          
                  className={inputStyles.mdInput}
                  placeholder="Enter Age"
                  style={{ width: "180px" }}
                  onChange={(age) => {
                    if (Number.isInteger(age) && age >= 0) {
                      const year = dayjs().year() - age;
                      const dob = dayjs(`${year}-01-01`);
                      form.setFieldValue("dob", dob);
                    } else {
                      form.setFieldValue("dob", null);
                    }
                  }}
                  onKeyDown={(e) => {
                    if (["-", "+", "e", ".", ",","/"].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                />
              </Form.Item>

            </Col>
          </Row>
      <Form.Item
        label="Gender"
        name={"gender"}
        rules={[{ required: true, message: "Please select gender" }]}
      >
        <Select
          allowClear
          placeholder="Gender"
          className={inputStyles.mdSelect}
          style={{ width: "300px" }}
          options={genderKeys}
        />
      </Form.Item>
      <Form.Item
        label="Email"
        name={"email"}
        rules={[{ type: "email", message: "Please enter a valid email" }]}
      >
        <Input
          placeholder="Enter email"
          className={inputStyles.mdInput}
          style={{ width: "300px" }}
        />
      </Form.Item>
      <Form.Item label="Address" name={"address"}>
        <Input.TextArea
          placeholder="Address"
          className={inputStyles.mdInput}
          style={{ width: "300px" }}
        />
      </Form.Item>
    </>
  );
};

export default PatientDetailsForm;
